export default ({...props}) => {
  const {palette, breakpoints, borderWeight, space} = props.theme
  return `
        padding: ${space(2)}px;
        &[ap_type="app_layout"] {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          background-color: ${palette.primary.main}20;
          max-width: 100%;
          flex-grow: 1;
          padding: 0px;
        }
        &[ap_type="app_header"] {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          max-width:100%;
          padding-left:40px;
          
        }
        &[ap_type="app_content_area_wrapper"] {
          flex-grow: 1;
          padding: ${space(2)}px;
          @media (max-width: ${breakpoints.values.md}px){
            padding: 0px;
          }
        }
        &[ap_type="app_content_area"] {
          background-color: ${palette.primary.contrastText};
          min-height: 100%;
          height: 100%;
        }
        &[ap_type="app_footer_wrapper"] {
          max-width: 100%;
          background-color: ${palette.primary.contrastText};
          border-top: ${borderWeight}px solid ${
    palette.secondary.contrastText
  }20;
        }
        &.transparent {
          background-color: transparent;
        }
`
}
